import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceNoteIssueRequestAttchmentContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { ApiVisa } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceNoteIssueRequestAttchmentService extends BaseApiTemplateService<ServiceNoteIssueRequestAttchmentContainerModel> {

  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/backoffice-ep';
    this.httpClient = http;
  }

   getRMARequestAttachmentFile(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    let url;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/file/backoffice-ep/'+ guid;
    }
    return this.httpClient.get<Blob>(
      url ,
      this.getHttpHeaderBlob(apiVisa)
    );
  }
}
